import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-black.png'


const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"sidebar-header\"><div class=\"row w-100 d-flex justify-content-center align-items-center mb-1 mt-1\"><div class=\"col-md-12 text-center\"><img src=\"" + _imports_0 + "\" alt=\"store\" style=\"width:120px;\"></div></div><div class=\"sidebar-toggler not-active\"><span></span><span></span><span></span></div></div>", 1)
const _hoisted_3 = { class: "sidebar-body" }
const _hoisted_4 = {
  class: "nav mb-5",
  style: {"padding-bottom":"45px !important"}
}
const _hoisted_5 = { class: "nav-item mb-2" }
const _hoisted_6 = { class: "link-title" }
const _hoisted_7 = { class: "nav-item mb-2" }
const _hoisted_8 = { class: "link-title" }
const _hoisted_9 = { class: "nav-item mb-2" }
const _hoisted_10 = { class: "link-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: 'clubs', params: { userUUID: _ctx.userUUID } },
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "store",
                size: "lg",
                class: "link-icon"
              }),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.i18n.t('layout.sidbar.admin.clubs')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: { name: 'users', params: { userUUID: _ctx.userUUID } },
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "users",
                size: "lg",
                class: "link-icon"
              }),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.i18n.t('layout.sidbar.admin.assistance')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: { name: 'assign-user' },
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "key",
                size: "lg",
                class: "link-icon"
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.i18n.t('layout.sidbar.admin.acces_assistance')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}